import { c as _c } from "react/compiler-runtime";
import { LightButton, Modal, ModalSizeEnum, PrimaryButton, SecondaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { updateMailingDoubleOptInSettings } from 'modules/profile/mailing-settings/api/mailing-settings-double-opt-in-api';
import { useMailingDoubleOptIn } from 'modules/profile/mailing-settings/hooks/use-mailing-double-optin';
import React, { useCallback, useEffect, useState } from 'react';
import DashboardMailEditor from 'shared/components/dashboard-mail-editor';
import { useUnsavedEmail } from 'shared/components/dashboard-mail-editor/hooks/use-unsaved-email';
import { AttachmentFileInterface, EmailBaseInterface, EmailErrorResponseContentInterface, EmailErrorType, UnsavedAttachmentFileInterface } from 'shared/components/dashboard-mail-editor/types/email-interface';
import { getMailingUpdateData } from 'shared/components/dashboard-mail-editor/utils/get-mailing-update-data';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { MailingDoubleOptInSettingsInterface } from '../types/mailing-settings-double-optin-interface';
const defaultErrors: EmailErrorType = {
  body: '',
  fromEmail: '',
  fromName: '',
  subject: '',
  previewText: '',
  common: []
};
function DoubleOptInModal() {
  const $ = _c(68);
  const {
    t
  } = useLocoTranslation();
  const [errors, setErrors] = useState(defaultErrors);
  const [isFetching, setIsFetching] = useState(false);
  const [opened, setOpened] = useState(false);
  const [tempState, setTempState] = useState();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [attachmentsTempState, setAttachmentsTempState] = useState(t0);
  const [shouldFetchDoubleOptIn, setShouldFetchDoubleOptIn] = useState(false);
  let t1;
  if ($[1] !== shouldFetchDoubleOptIn) {
    t1 = {
      shouldFetch: shouldFetchDoubleOptIn
    };
    $[1] = shouldFetchDoubleOptIn;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    mailingDoubleOptInSettings,
    mutateOptInSettings
  } = useMailingDoubleOptIn(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ruleEmail => {
      if (ruleEmail) {
        setTempState(prev => ({
          ...prev,
          ...ruleEmail.currentEmail
        }));
        setAttachmentsTempState(ruleEmail.currentEmail.attachments);
      }
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const setEmail = t2;
  let t3;
  let t4;
  if ($[4] !== mailingDoubleOptInSettings) {
    t3 = () => {
      setEmail(mailingDoubleOptInSettings);
    };
    t4 = [mailingDoubleOptInSettings, setEmail];
    $[4] = mailingDoubleOptInSettings;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  const handleConfirm = async () => {
    ;
    try {
      if (tempState) {
        const doubleOptInData = {
          currentEmail: getMailingUpdateData({
            body: tempState.body,
            fromEmail: tempState.fromEmail,
            fromName: tempState.fromName,
            subject: tempState.subject,
            previewText: tempState.previewText
          }, attachmentsTempState)
        };
        setErrors(defaultErrors);
        setIsFetching(true);
        const response = await updateMailingDoubleOptInSettings(doubleOptInData);
        await mutateOptInSettings(data => {
          if (data) {
            return {
              ...response.data
            };
          }
        }, false);
        await removeDbRecord();
        onClose();
        toast.success(t("global.changes_saved"));
      }
    } catch (t5) {
      const e = t5;
      setIsFetching(false);
      if (e instanceof BadRequest) {
        const mailingDoubleOptInSettingsErrors = e.errors as unknown as EmailErrorResponseContentInterface;
        const fieldErrors = mailingDoubleOptInSettingsErrors.fields.currentEmail;
        if (fieldErrors) {
          setErrors(prev_0 => ({
            ...prev_0,
            body: fieldErrors.body?.join(""),
            fromEmail: fieldErrors.fromEmail?.join(""),
            fromName: fieldErrors.fromName?.join(""),
            subject: fieldErrors.subject?.join(""),
            previewText: fieldErrors.previewText?.join("")
          }));
        }
        if (e.errors.common) {
          const commonErrors = e.errors.common;
          setErrors(prev_1 => ({
            ...prev_1,
            common: commonErrors
          }));
        }
      } else {
        toast.error(t("global.error"));
      }
    }
  };
  const onClose = () => {
    setOpened(false);
    setIsFetching(false);
  };
  const t6 = mailingDoubleOptInSettings?.id;
  const t7 = mailingDoubleOptInSettings?.currentEmail.body;
  const t8 = tempState?.body;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = data_0 => setTempState(prev_2 => prev_2 && {
      ...prev_2,
      body: data_0
    });
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t6 || $[9] !== t7 || $[10] !== t8) {
    t10 = {
      mailingId: t6,
      initialBody: t7,
      currentBody: t8,
      onPaste: t9
    };
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const {
    UnsavedEmailConfirmationModal,
    removeDbRecord: t11,
    setNeedToShowModal
  } = useUnsavedEmail(t10);
  const removeDbRecord = t11;
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = value => setTempState(value);
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const onChangeEmail = t12;
  let t13;
  if ($[13] !== mailingDoubleOptInSettings) {
    t13 = () => {
      setEmail(mailingDoubleOptInSettings);
      setErrors(defaultErrors);
      setShouldFetchDoubleOptIn(false);
    };
    $[13] = mailingDoubleOptInSettings;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  const onAfterLeave = t13;
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => {
      setOpened(true);
      setShouldFetchDoubleOptIn(true);
    };
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const t15 = shouldFetchDoubleOptIn && !mailingDoubleOptInSettings;
  let t16;
  if ($[16] !== t) {
    t16 = t("dashboard.settings.mailing.double_opt_in_edit_button_title");
    $[16] = t;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== t15 || $[19] !== t16) {
    t17 = <LightButton className="bg-background-secondary border-text-secondary/30 border border-solid" onClick={t14} isFetching={t15}>{t16}</LightButton>;
    $[18] = t15;
    $[19] = t16;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  const t18 = opened && !!mailingDoubleOptInSettings;
  let t19;
  if ($[21] !== setNeedToShowModal) {
    t19 = () => setNeedToShowModal(true);
    $[21] = setNeedToShowModal;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] !== t) {
    t20 = t("dashboard.settings.mailing.double_opt_in_edit_modal.title");
    $[23] = t;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  const t21 = !mailingDoubleOptInSettings;
  let t22;
  if ($[25] !== t) {
    t22 = t("dashboard.settings.mailing.double_opt_in_edit_modal.available_replacements_confirmation_link_title");
    $[25] = t;
    $[26] = t22;
  } else {
    t22 = $[26];
  }
  let t23;
  if ($[27] !== t22) {
    t23 = [{
      name: t22,
      slug: "double_opt_in_confirmation_link"
    }];
    $[27] = t22;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  let t24;
  if ($[29] !== attachmentsTempState || $[30] !== errors || $[31] !== t21 || $[32] !== t23 || $[33] !== tempState) {
    t24 = <DashboardMailEditor showSettingsLink={false} inModal={true} isPreFetching={t21} tempState={tempState} onChangeEmail={onChangeEmail} attachmentsTempState={attachmentsTempState} setAttachmentsTempState={setAttachmentsTempState} errors={errors} additionalSubstitutes={t23} />;
    $[29] = attachmentsTempState;
    $[30] = errors;
    $[31] = t21;
    $[32] = t23;
    $[33] = tempState;
    $[34] = t24;
  } else {
    t24 = $[34];
  }
  let t25;
  if ($[35] !== onClose) {
    t25 = e_0 => {
      e_0.preventDefault();
      onClose();
    };
    $[35] = onClose;
    $[36] = t25;
  } else {
    t25 = $[36];
  }
  let t26;
  if ($[37] !== t) {
    t26 = t("confirmation_modal.cancel");
    $[37] = t;
    $[38] = t26;
  } else {
    t26 = $[38];
  }
  let t27;
  if ($[39] !== t25 || $[40] !== t26) {
    t27 = <SecondaryButton width="large" onClick={t25} type="submit">{t26}</SecondaryButton>;
    $[39] = t25;
    $[40] = t26;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  if ($[42] !== handleConfirm) {
    t28 = async e_1 => {
      e_1.preventDefault();
      await handleConfirm();
    };
    $[42] = handleConfirm;
    $[43] = t28;
  } else {
    t28 = $[43];
  }
  let t29;
  if ($[44] !== t) {
    t29 = t("global.save");
    $[44] = t;
    $[45] = t29;
  } else {
    t29 = $[45];
  }
  let t30;
  if ($[46] !== isFetching || $[47] !== t28 || $[48] !== t29) {
    t30 = <PrimaryButton width="large" onClick={t28} isFetching={isFetching} disabled={isFetching}>{t29}</PrimaryButton>;
    $[46] = isFetching;
    $[47] = t28;
    $[48] = t29;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  let t31;
  if ($[50] !== t27 || $[51] !== t30) {
    t31 = <div className="flex justify-center gap-4">{t27}{t30}</div>;
    $[50] = t27;
    $[51] = t30;
    $[52] = t31;
  } else {
    t31 = $[52];
  }
  let t32;
  if ($[53] !== t24 || $[54] !== t31) {
    t32 = <form className="flex flex-col gap-6 lg:gap-7">{t24}{t31}</form>;
    $[53] = t24;
    $[54] = t31;
    $[55] = t32;
  } else {
    t32 = $[55];
  }
  let t33;
  if ($[56] !== UnsavedEmailConfirmationModal || $[57] !== isFetching || $[58] !== onAfterLeave || $[59] !== onClose || $[60] !== t18 || $[61] !== t19 || $[62] !== t20 || $[63] !== t32) {
    t33 = <Modal opened={t18} onClose={onClose} afterEnter={t19} afterLeave={onAfterLeave} title={t20} isFetching={isFetching} size={ModalSizeEnum.big}>{t32}{UnsavedEmailConfirmationModal}</Modal>;
    $[56] = UnsavedEmailConfirmationModal;
    $[57] = isFetching;
    $[58] = onAfterLeave;
    $[59] = onClose;
    $[60] = t18;
    $[61] = t19;
    $[62] = t20;
    $[63] = t32;
    $[64] = t33;
  } else {
    t33 = $[64];
  }
  let t34;
  if ($[65] !== t17 || $[66] !== t33) {
    t34 = <>{t17}{t33}</>;
    $[65] = t17;
    $[66] = t33;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  return t34;
}
export default DoubleOptInModal;